import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils"
import RoutesMap from "../../../../route_control/RouteControl"

export const assetItemByLocationTodo = createAsyncThunk('assetItemByLocation', async (data) => {
    // console.log(data)
    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item_by_location`,
            params: {
                'location_id': data?.locationId,
                'sub_location_id': data?.subLocationId,
                'block_id': data?.blockId,
                'staff_id': data?.personId,
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetItemByLocationSlice = createSlice({
    name: 'itemByLocation',
    initialState: {
        data: [],
    },
    reducers: {
        removeItems: (state, action) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(assetItemByLocationTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(assetItemByLocationTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { removeItems } = assetItemByLocationSlice.actions;
export default assetItemByLocationSlice.reducer; 